import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContainer } from "./MainLayoutStyled";
import { MainContext } from "../context/MainContext";
import SiteHeader from "../components/SiteHeader";

const AuthLayout = ({ children }) => {
    const location = useLocation();
    const { isLoggedContext } = useContext(MainContext);
    const [isLogged] = isLoggedContext;

    if (isLogged) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/" state={ { from: location } } replace/>;
    }

    return (
        <>
            <SiteHeader/>
            <AuthContainer>{ children }</AuthContainer>
        </>
    );
};

export default AuthLayout;
